import React, { useEffect, useState, useRef } from 'react'; 
import { MdSearch } from "react-icons/md"; 
import { RxCross2 } from "react-icons/rx"; 
import { useNavigate } from 'react-router-dom'; 
import { API_BASE_URL, get } from '../../services/ApiRouting'; 
import "../SearchComponent/SearchPage.css"; 
import { useCurrency } from '../../services/locationService';

const IMAGE_BASE_URL = 'https://1fiveglobal.in/uploads/productsImages/';

const SearchPage = ({ toggleSearch, isSearchOpen }) => { 
    const { format } = useCurrency();
    const [visible, setVisible] = useState(false); 
    const [searchTerm, setSearchTerm] = useState(""); 
    const [products, setProducts] = useState([]); 
    const [isTyping, setIsTyping] = useState(false); 
     
    const debounceTimer = useRef(null); 
    const navigate = useNavigate(); 

    const handleNavigate = (product) => { 
        if (!product) return;

        // Extract values from product object safely
        const categorySlug = product.category_slug || 'products';
        const subcategorySlug = product.subcategory_slug || 'products';
        const productSlug = product.slug;

        // Navigate using /category-slug/product-slug format
        navigate(`/${categorySlug}/${subcategorySlug}/${productSlug}`); 

        // Close search popup & reset search term
        if (toggleSearch) toggleSearch();
        setVisible(false); 
        setSearchTerm(""); 
    }; 

    useEffect(() => { 
        if (isSearchOpen) { 
            setVisible(true); 
        } else { 
            setTimeout(() => setVisible(false), 500); 
        } 
    }, [isSearchOpen]); 

    useEffect(() => { 
        if (searchTerm.trim().length > 2) { 
            setIsTyping(true); 

            if (debounceTimer.current) { 
                clearTimeout(debounceTimer.current); 
            } 

            debounceTimer.current = setTimeout(() => { 
                fetchProducts(); 
                setIsTyping(false); 
            }, 500); 
        } else {
            setProducts([]);
        }
    }, [searchTerm]); 

    const fetchProducts = async () => { 
        try { 
            const response = await get( 
                `${API_BASE_URL}products?search=${encodeURIComponent(searchTerm)}&limit=4&page=1` 
            ); 
            
            if (response && response.success) {
                setProducts(response.data || []); 
            } else {
                setProducts([]);
            }
        } catch (error) { 
            console.error("Error fetching products:", error); 
            setProducts([]);
        } 
    }; 

    return ( 
        <> 
            {visible && ( 
                <section className={`search-section ${isSearchOpen ? 'show' : 'hide'}`}> 
                    <div className='container'> 
                        <div className='search-display-info'> 
                            <h3>{products.length} result{products.length !== 1 ? 's' : ''} for {searchTerm}</h3> 
                        </div> 
                        <div className='search-section-main-con'> 
                            <div className='search-section-con'> 
                                <div className='search-icons-con'> 
                                    <MdSearch /> 
                                </div> 
                                <div className='search-bar-main-con'> 
                                    <input 
                                        type="text" 
                                        placeholder="Search" 
                                        value={searchTerm} 
                                        onChange={(e) => setSearchTerm(e.target.value)} 
                                        style={{ color: "white" }} 
                                    /> 
                                </div> 
                                <div className='search-cancel-con' onClick={toggleSearch}> 
                                    <RxCross2 /> 
                                </div> 
                            </div> 
                        </div> 
                    </div> 
                    <div className='search-section-2'> 
                        <div className='search-section2-main-con'> 
                            <div className='row product-list-row'> 
                                {searchTerm.trim().length > 2 ? ( 
                                    products.length > 0 ? ( 
                                        products.map((product) => {
                                            const primaryImg = product.images?.[0]?.image 
                                                ? `${IMAGE_BASE_URL}${product.images[0].image}` 
                                                : '/placeholder.jpg';
                                            
                                            const secondaryImg = product.images?.[1]?.image 
                                                ? `${IMAGE_BASE_URL}${product.images[1].image}` 
                                                : primaryImg;

                                            return (
                                                <div key={product.id} className='col-lg-3 col-md-4 col-sm-6 col-12 product-list-col'> 
                                                    <div className="product-card-main-con" onClick={() => handleNavigate(product)}> 
                                                        <div className="product-card-body-con"> 
                                                            <div className="product-card-Image-con product-item__image double__image"> 
                                                                <div className="product-card-Image-con product-item__image double__image new-product-item__bg"> 
                                                                    <div className="product-item__bg"> 
                                                                        <img src={primaryImg} alt={product.name} /> 
                                                                    </div> 
                                                                    <div className="product-item__bg__under"> 
                                                                        <img src={secondaryImg} alt={product.name} /> 
                                                                    </div> 
                                                                </div> 
                                                            </div> 
                                                            <div className="Product-card-details-con"> 
                                                                <div className="Product-card-details"> 
                                                                    <div className="product-card-product-name"> 
                                                                        <h4>{product.name}</h4> 
                                                                    </div> 
                                                                    {/* <div className="Product-card-product-review-price"> 
                                                                        <h6>{format(product.price)}</h6> 
                                                                    </div>  */}
                                                                </div> 
                                                            </div> 
                                                        </div> 
                                                    </div> 
                                                </div> 
                                            );
                                        }) 
                                    ) : ( 
                                        <div className='product-card-search-not-found-text'> 
                                            <h3>No results found</h3> 
                                        </div> 
                                    ) 
                                ) : null} 
                            </div> 

                            {products.length >= 4 && ( 
                                <div className='search-popup-btn-main-con'> 
                                    <button onClick={() => {
                                        navigate(`/search?query=${encodeURIComponent(searchTerm)}`);
                                        if (toggleSearch) toggleSearch();
                                    }}>
                                        View More
                                    </button> 
                                </div> 
                            )} 
                        </div> 
                    </div> 
                </section> 
            )} 
        </> 
    ); 
}; 

export default SearchPage;